import React from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../helpers'

export const LANGUAGE_KEY = {
  EN: 'en',
  ZH: 'zh',
  JA: 'ja',
}

export const PREFERRED_LANGUAGE_KEY = 'preferred_language'

export const LanguageConfig = () => {
  const intl = useIntl()

  return {
    LANGUAGES: [
      {
        value: LANGUAGE_KEY.EN,
        label: (
          <>
            <img
              className='w-15px h-15px rounded-1 me-2'
              src={toAbsoluteUrl('/media/flags/united-states.svg')}
              alt='United-states'
            />
            {intl.formatMessage({id: 'ENGLISH'})}
          </>
        ),
        flag: toAbsoluteUrl('/media/flags/united-states.svg'),
      },
      {
        value: LANGUAGE_KEY.ZH,
        label: (
          <>
            <img
              className='w-15px h-15px rounded-1 me-2'
              src={toAbsoluteUrl('/media/flags/china.svg')}
              alt='China'
            />
            {intl.formatMessage({id: 'CHINESE'})}
          </>
        ),
        flag: toAbsoluteUrl('/media/flags/china.svg'),
      },
      {
        value: LANGUAGE_KEY.JA,
        label: (
          <>
            <img
              className='w-15px h-15px rounded-1 me-2'
              src={toAbsoluteUrl('/media/flags/japan.svg')}
              alt='Japan'
            />
            {intl.formatMessage({id: 'JAPANESE'})}
          </>
        ),
        flag: toAbsoluteUrl('/media/flags/japan.svg'),
      },
    ],
  }
}
